module.exports = __webpack_public_path__ + "static/img/4.b192369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Conference/4.png
// module id = ol1K
// module chunks = 1